<template>
    <BreadCrumb PageTitle="Faire un remboursement" />
    <AddRemboursement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddRemboursement from "../../components/Remboursement/AddRemboursement.vue";
    export default defineComponent({
      name: "AddRemboursementPage",
      components: {
        BreadCrumb,
        AddRemboursement,
      },
    });
  </script>